import {
  type QueryClient,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { api, unwrap } from "@/shared/lib/apiClient";
import { overviewKeys, setupKeys } from "@/shared/lib/queryKeys";
import type { AbsenceFormValues } from "../attendance.schemas";

// Raid days and absences feed both the schedule grid and the setup planner.
const invalidateOverviewAndSetup = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: overviewKeys.all });
  queryClient.invalidateQueries({ queryKey: setupKeys.all });
};

export function useCreateAbsence() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: AbsenceFormValues) =>
      unwrap(await api.POST("/api/absences", { body })),
    onSuccess: () => invalidateOverviewAndSetup(queryClient),
  });
}

export function useUpdateAbsence() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...body }: AbsenceFormValues & { id: string }) =>
      unwrap(
        await api.PUT("/api/absences/{id}", {
          params: { path: { id } },
          body,
        }),
      ),
    onSuccess: () => invalidateOverviewAndSetup(queryClient),
  });
}

export function useDeleteAbsence() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      unwrap(
        await api.DELETE("/api/absences/{id}", {
          params: { path: { id } },
        }),
      );
    },
    onSuccess: () => invalidateOverviewAndSetup(queryClient),
  });
}
